import { TabbarProps, TabbarOption } from "./types/tabbarProps";
import './tabbar.scss'
import { AdditionalIcon } from "../additionalIcon/additionalIcon";

const Tabbar = (props: TabbarProps) => {
    const liCreate = (name?: string) => {
        return (<span className="body-txt-medium" style={{ width: props.spanView ? '0px' : props.tabWidth ? props.tabWidth : '130px' }}>{name}</span>)
    }

    var iconStylization: React.CSSProperties = {
        display: 'inline-block',
        verticalAlign: 'middle'
    }

    const options = () => {
        return props.options?.map((option: TabbarOption, index: number) => {
            var iconStyle = option.additionalIconStyle ? option.additionalIconStyle : iconStylization;
            return (
                <li key={index + 1} className={props.options?.length === 1 ? 'activeTab' : (props.selected === index + 1 ? 'activeTab' : undefined)} tabIndex={index + 1} onClick={option.onClick}>
                    {AdditionalIcon(option.additionalIcon, iconStyle)}
                    {liCreate(option.name)}
                </li>
            )
        })
    }

    return (
        <ul className={props.className ? props.className : "tabbar"} style={props.style}>
            {options()}
        </ul>
    )
}

export default Tabbar;